import request from '@/utils/request'

export function updateLangCfg(data) {
  return request({
    url: 'api/v1/lang/updateLang',
    method: 'post',
    data: data
  })
}

export function getLangCfg(data) {
  return request({
    url: 'api/v1/lang/getLang',
    method: 'post',
    data: data
  })
}

export function getLangCfgList(data) {
  return request({
    url: 'api/v1/lang/getList',
    method: 'post',
    data: data
  })
}

export function delLangCfg(data) {
  return request({
    url: 'api/v1/lang/delLang',
    method: 'delete',
    data: data
  })
}
export function exportLangCfg() {
  return request({
    url: 'api/v1/lang/export',
    method: 'get' })
}

export function importLangCfg(data) {
  return request({
    url: 'api/v1/lang/import',
    method: 'post',
    data: data,
    timeout: 100000
  })
}

